/**
 * 관리자 가맹점 관리 API 서비스
 */

import { apiGet, apiPut, apiPutFormData, apiDelete } from "./apiClient";

/**
 * 승인 대기 가맹점 목록 조회 (페이지네이션)
 */
export const getReadyStores = async (page = 0, size = 10) => {
  try {
    const response = await apiGet(`/admin/store?page=${page}&size=${size}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "승인 대기 가맹점 목록을 불러오는데 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 탈퇴 요청 가맹점 목록 조회
 */
export const getWithdrawalStores = async (page = 0, size = 10, sortBy = 'withdrawalRequestTime', sortDir = 'desc') => {
  try {
    const response = await apiGet(`/admin/store/withdrawal?page=${page}&size=${size}&sort=${sortBy},${sortDir}`);
    if (response.ok) {
      const data = await response.json();
      return { success: true, data, error: null };
    } else {
      return { success: false, data: null, error: "탈퇴 요청 가맹점 목록을 불러오는데 실패했습니다." };
    }
  } catch (error) {
    return { success: false, data: null, error: "네트워크 오류가 발생했습니다." };
  }
};

/**
 * 모든 가맹점 목록 조회 (페이지네이션)
 */
export const getAllStores = async (page = 0, size = 10, sortBy = 'approvedDateTime', sortDir = 'desc') => {
  try {
    const response = await apiGet(`/admin/store/all?page=${page}&size=${size}&sort=${sortBy},${sortDir}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 목록을 불러오는데 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 가맹점 승인 대기 상세 조회
 */
export const getPendingStoreDetail = async (storeCode) => {
  try {
    const response = await apiGet(`/admin/store/pending/${storeCode}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 정보를 불러오는데 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};


/**
 * 가맹점 상세 조회
 */
export const viewStoreDetail = async (storeCode) => {
  try {
    const response = await apiGet(`/admin/store/${storeCode}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 정보를 불러오는데 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 가맹점 승인 처리
 */
export const approveStore = async (storeCode, storeNote) => {
  try {
    const response = await apiPut(`/admin/store/approve/${storeCode}`, {
      storeNote,
    });

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 승인에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};


/**
 * 가맹점 거절 처리
 */
export const rejectStore = async (storeCode, reason) => {
  try {
    const response = await apiPut(`/admin/store/reject/${storeCode}`, {
      reason,
    });

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 거절에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 가맹점 제재
 */
export const suspendStore = async (storeCode) => {
  try {
    const response = await apiPut(`/admin/store/suspend/${storeCode}`, {});
    if (response.ok) {
      return { success: true, data: null, error: null };
    }
    const errorText = await response.text().catch(() => "");
    return { success: false, data: null, error: errorText || "제재 처리에 실패했습니다." };
  } catch (error) {
    return { success: false, data: null, error: "네트워크 오류가 발생했습니다." };
  }
};

export const unsuspendStore = async (storeCode) => {
  try {
    const response = await apiPut(`/admin/store/unsuspend/${storeCode}`, {});
    if (response.ok) {
      return { success: true, data: null, error: null };
    }
    const errorText = await response.text().catch(() => "");
    return { success: false, data: null, error: errorText || "제재 해제에 실패했습니다." };
  } catch (error) {
    return { success: false, data: null, error: "네트워크 오류가 발생했습니다." };
  }
};

export const immediateWithdrawStore = async (storeCode) => {
  try {
    const response = await apiDelete(`/admin/store/immediate-withdraw/${storeCode}`);
    if (response.ok) {
      return { success: true, data: null, error: null };
    }
    const errorText = await response.text().catch(() => "");
    return { success: false, data: null, error: errorText ||"탈퇴 처리에 실패했습니다." };
  } catch (error) {
    return { success: false, data: null, error: "네트워크 오류가 발생했습니다." };
  }
};

/**
 * 가맹점 정보 수정
 */
export const modStoreInfo = async (storeCode, formData) => {
  try {
    const response = await apiPutFormData(`/admin/store/modStoreInfo/${storeCode}`, formData); // FormData 객체

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 정보 수정에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 구독 정보 수정
 */
export const modSubsInfo = async (storeCode, subsInfo) => {
  try {
    const response = await apiPut(`/admin/store/modSubsInfo/${storeCode}`, subsInfo);

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "구독 정보 수정에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 사용자 정보 수정
 */
export const modMemberInfo = async (storeCode, memberInfo) => {
  try {
    const response = await apiPut(`/admin/store/modMemberInfo/${storeCode}`, memberInfo);

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "사용자 정보 수정에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 사업자 정보 수정
 */
export const modBizInfo = async (storeCode, bizInfo) => {
  try {
    const response = await apiPut(`/admin/store/modBizInfo/${storeCode}`, bizInfo);

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "사업자 정보 수정에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 권한 정보 수정
 */
export const modAuthInfo = async (storeCode, authInfo) => {
  try {
    const response = await apiPut(`/admin/store/modAuthInfo/${storeCode}`, authInfo);

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "권한 정보 수정에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 비밀번호 변경
 */
export const modMemberPassword = async (storeCode, data) => {
  try {
    const response = await apiPut(`/admin/store/modPw/${storeCode}`, data);

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "비밀번호 변경에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 매니저(직원) 비밀번호 변경
 */
export const modManagerPassword = async (memberId, data) => {
  try {
    const response = await apiPut(`/admin/store/${memberId}/modPw`, data);

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "매니저 비밀번호 변경에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 가맹점 상세 조회
 */
export const getStoreDetail = async (storeCode) => {
  try {
    const response = await apiGet(`/admin/store/${storeCode}`);


    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 상세 정보를 불러오는데 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 가맹점 검색 (페이지네이션)
 */
export const searchStores = async (searchParams, page = 0, size = 10, sortBy = 'approvedDateTime', sortDir = 'desc') => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      sort: `${sortBy},${sortDir}`,
      ...searchParams
    });

    const response = await apiGet(`/admin/store/search?${params.toString()}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 검색에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};


export const searchAccept = async (searchParams, page = 0, size = 10) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("size", size);

    if (searchParams.bizType && searchParams.bizType !== "") {
      params.append("bizType", searchParams.bizType);
    }
    if (searchParams.startDate) {
      params.append("startDate", searchParams.startDate);
    }
    if (searchParams.endDate) {
      params.append("endDate", searchParams.endDate);
    }
    if (searchParams.searchType) {
      params.append("searchType", searchParams.searchType);
    }
    if (searchParams.searchTerm) {
      params.append("searchTerm", searchParams.searchTerm);
    }

    const response = await apiGet(`/admin/store/pendingSearch?${params.toString()}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "가맹점 검색에 실패했습니다."
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다."
    };
  } 
}

/**
 * 매니저(직원) 삭제
 */
export const deleteManager = async (memberId) => {
  try {
    const response = await apiDelete(`/admin/store/${memberId}`);

    if (response.ok) {
      return {
        success: true,
        data: await response.text(),
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "매니저 삭제에 실패했습니다.",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};